import { HostListener, Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  HttpClient,
  HttpErrorResponse,
  HttpRequest,
  HttpHandler,
  HttpResponse,
  HttpEvent,
} from '@angular/common/http';
import { Observable, Subject, throwError } from 'rxjs';
import { map, tap, finalize } from 'rxjs/operators';
import { environment } from './../../../../../environments/environment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from '@angular/material/snack-bar';
import { isPlatformBrowser } from '@angular/common';

import {
   SnackBarMessage,
} from './../../../models/index';
// import { CookieService } from 'ngx-cookie-service';
// import { CommonService } from '../common/common.service';
// import { routes } from '../../loader-less-routes/routes';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  horizontalPosition: MatSnackBarHorizontalPosition = 'start';
  verticalPosition: MatSnackBarVerticalPosition = 'bottom';
  rfqData(arg0: { limit: number; offset: number }) {
    throw new Error('Method not implemented.');
  }
  SERVER_URL = environment.SERVER_URL;
  sideBarHeight: number = 0;
  page: any;
  profile: any;
  isLoading: any;
  storeItemVal: any;
  userData = new Subject();
  hideLoader = new Subject<boolean>();

  constructor(
    private loader: NgxUiLoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpClient,
    private _snackBar: MatSnackBar,
    // private cookieService: CookieService,
    // private commonService: CommonService,
    @Inject(PLATFORM_ID) private platform: Object
  ) {
    // window.addEventListener("beforeunload", function (e) {
    //   console.log("jssjjs");
    //   commonService.logout()

    // });
    // alert(env.production)
  }



  objToQueryString(obj: any): string {
    if (!obj) {
      return '';
    }

    const searchParams = new URLSearchParams();
    const params = obj;
    Object.keys(params).forEach((key) => searchParams.append(key, params[key]));

    return searchParams.toString();
  }

  isRequestFromBrowser() {
    if (!isPlatformBrowser(this.platform)) {
      // Need for SSR setup
      return false;
    } else {
      return true;
    }
  }

  getToken() {
    if (!this.isRequestFromBrowser()) {
      // Need for SSR setup
      return null;
    }

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.getItem('token');
    }
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'no'
    ) {
      return sessionStorage.getItem('token');
    } else {
      return null;
    }
  }

  // intercept(
  //   request: HttpRequest<any>,
  //   next: HttpHandler
  // ): Observable<HttpEvent<any>> {
  //   const started = Date.now();

  //   const headers = {
  //     session_id: this.getCookie('_session'),
  //   };

  //   let ok: any;
  //   const token = this.getToken();

  //   if (token) {
  //     // make sure token is coming,
  //     request = request.clone({
  //       setHeaders: {
  //         Authorization: `Bearer ${token}`,
  //         ...headers,
  //       },
  //     });
  //   } else {
  //     request = request.clone({
  //       setHeaders: headers,
  //     });
  //   }

  //   return next.handle(request).pipe(
  //     tap(
  //       // Succeeds when there is a response; ignore other events
  //       (event) => (ok = event instanceof HttpResponse ? 'succeeded' : ''),
  //       // Operation failed; error is an HttpErrorResponse
  //       (error) => (ok = error)
  //     ),
  //     // Log when response observable either completes or errors
  //     finalize(() => {
  //       this.loader.stop();
  //       const elapsed = Date.now() - started;
  //       if (ok == 'succeeded') {
  //         const msg = `${request.method} "${request.urlWithParams}"
          
  //          ${ok} in ${elapsed} ms.`;
  //         //  For make sure how much time consumed
  //         // console.log(msg);
  //       } else {
  //         console.log(ok);
  //         console.log('request: ', request);
  //         if (ok['status'] == 401) {
  //           // logout from here
  //           this.router.navigate(['/']);
  //           console.log(ok['status']);
  //         } else {
  //           if (request.url.search('users/bulkUploadProducts') == -1) {
  //             this.handleError(ok);
  //           }
  //         }
  //       }
  //     })
  //   );
  // }

  isAuthenticated() {
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.getItem('isLogged') == 'true';
    }
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'no'
    ) {
      return localStorage.getItem('isLogged') == 'true';
    } else {
      return false;
    }
  }

 // setCookies(obj: AddCookie): void {
    //this.cookieService.set(obj.key, obj.value, obj.expires);
 // }

  getCookie(key: string): string {
    return ""
    //return this.cookieService.get(key);
  }

  deleteCookie(key: string): void {
    //this.cookieService.delete(key);
  }

  loggedUserDetails() {
    if (!this.isRequestFromBrowser()) {
      // Need for SSR setup
      return null;
    }

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return JSON.parse(localStorage.getItem('user_details') || '{}');
    }
    if (localStorage.getItem('remember_me')) {
      return JSON.parse(sessionStorage.getItem('user_details') || '{}');
    } else {
      return null;
    }
  }

  setLoggedUserDetails(object: any) {
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      localStorage.setItem('user_details', JSON.stringify(object));
    }
    if (localStorage.getItem('remember_me')) {
      sessionStorage.setItem('user_details', JSON.stringify(object));
    } else {
    }
  }

  setDataInLocalStorage(
    key: any,
    value: any,
    isObjectOrArray: boolean = false
  ) {
    if (isObjectOrArray) localStorage.setItem(key, value);

    if (isObjectOrArray) localStorage.setItem(key, JSON.stringify(value));

    return true;
  }

  getDataFromLocalStorage(key: any, isObjectOrArray: boolean = false): any {
    if (!localStorage.getItem(key)) return '';

    if (isObjectOrArray) return JSON.parse(localStorage.getItem(key) || '{}');

    return localStorage.getItem(key);
  }

  addBodyClass() {
    const bodyTag = document.body;
    bodyTag.classList.add('my-class');
  }
  removeBodyClass() {
    const bodyTag = document.body;
    bodyTag.classList.remove('my-class');
  }

  showSuccessMessage(object: SnackBarMessage) {
    // this.addBodyClass()
    let snackBarRef = this._snackBar.open(
      object.message,
      object.action ? object.action : 'CLOSE',
      {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: ['my_snackbar'],
      }

    );
    // snackBarRef.afterDismissed().subscribe(() => {
    //  this.removeBodyClass()
    // });
  }

  showErrorMessage(object: SnackBarMessage) {
    this.addBodyClass()
    let snackBarRef = this._snackBar.open(
      object.message,
      object.action ? object.action : 'CLOSE',

      {

        duration: undefined,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: ['my_snackbar'],
      }

    );
    // snackBarRef.afterDismissed().subscribe(() => {
    //   this.removeBodyClass()
    // });
  }

   registrationForm(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/upload/student/to/school`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  updateLoginDetails(details: any) {
    // whenever talent/talent edit name and name will reflect

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.setItem('admin_details', JSON.stringify(details));
    }
    if (localStorage.getItem('remember_me')) {
      return sessionStorage.setItem('admin_details', JSON.stringify(details));
    }
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error && error.error.errors) {
      // client-side error and server side
      if (Array.isArray(error.error.errors.msg)) {
        // validation error message

        if (error.error.errors.msg.length) {
          console.log(error.error.errors.msg, "(error.error.errors.msg");

          const ob = error.error.errors.msg[0];
          if (ob.msg == 'IS_EMPTY') {
            errorMessage = `${ob.param} missing`;
          } else {
            errorMessage = ob.msg;
          }
        }
      } else {
        errorMessage = error.error.errors.msg;
      }
    } else {
      // server-side error
      if (error.status == 401) {
        // Unauthorised
        // this.commonService.logout();
        this.router.navigate(['/']);
      }

      console.log(error);
      if (navigator.onLine == false) {
        errorMessage = `Please check your internet connection!`;
      }
      else {

        errorMessage = `Something went wrong here`;
      }
      // errorMessage = `${error.message}`;
    }
    console.log('I am here ', errorMessage);
    // if (this.bulkUpload(error)) {
    //   return;
    // }
    this.showErrorMessage({
      message: errorMessage,
    });
    return throwError(errorMessage);
  }

  getProfiledata(data:any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getUserProfile?registrationNo=${data}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
 
  getProfiledataSchool(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/get/school`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  editProfile(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/edit/student`;
    return this.http.put(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }


  editProfileForSchool(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/edit/school`;
    return this.http.put(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  uploadImage(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/file/upload`;
    return this.http.post(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }
  schoolBulkUpload(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/uploadSchoolBulk`;
    return this.http.post(API_URL, data,{
      reportProgress: true,
      observe: 'events',
    }).pipe(
      map((res) => {
        return res;
      })
    );
  }
   schoolBulkUploadnew(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/uploadedStudentList`;
    return this.http.post(API_URL, data,{
      reportProgress: true,
      observe: 'events',
    }).pipe(
      map((res) => {
        return res;
      })
    );
  }
   getstudentList(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getStudentList?${data}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getHomepageBanner(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getBannerList`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  
  getaboutMtse(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getAboutExam`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  //=======27FebAmitStart
  getExamList(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getHeroExamList`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  //=======27FebAmitEnd
   getsuccesspaymentList(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getStudentSuccessPayment?${data}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }


 latestUpdates(type:any): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getHomePageList?type=${type}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  //=======Amit28FebStart
getUserList(): Observable<any> {
  const API_URL = `${this.SERVER_URL}users/getqueryList`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
}
  //=======Amit28FebEnd

footerPage(): Observable<any> {
  const API_URL = `${this.SERVER_URL}users/getFooter`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
}

aboutUs() {
  const API_URL = `${this.SERVER_URL}users/getAboutUs`;
  return this.http.get(API_URL).pipe(
    map((res: any) => {
      return res;
    })
  );
}
contactUs(){
  const API_URL=`${this.SERVER_URL}users/getContactUs`;
  return this.http.get(API_URL).pipe(
    map((res:any)=>{
      return res;
    })
  )
};
privacyPolicy(data:any){
  const API_URL = `${this.SERVER_URL}users/getCmsByType?type=${data.type}`;
  return this.http.get(API_URL).pipe(
    map((res: any) => {
      return res;
    })
  );
}

FAQ(){
  const API_URL = `${this.SERVER_URL}users/getFaqList`;
  return this.http.get(API_URL).pipe(
    map((res: any) => {
      return res;
    })
  );
}


addNewsLetter(data: any): Observable<any> {
  const API_URL = `${this.SERVER_URL}users/news/letter/subscribe`;
  return this.http.post(API_URL, data).pipe(
    map((res) => {
      return res;
    })
  );
}
//-------Study Material School
schoolStudyMaterial(data:any){
  const query=this.objToQueryString(data)
  const API_URL = `${this.SERVER_URL}users/getListOfStudyMaterials?${query}`;
  return this.http.get(API_URL).pipe(
    map((res: any) => {
      return res;
    })
  );
}
//---------Mock test School
// schoolMockTest(data:any){
//   const query=this.objToQueryString(data)
//   const API_URL = `${this.SERVER_URL}users/getListOfStudyMaterials?${query}`;
//   return this.http.get(API_URL).pipe(
//     map((res: any) => {
//       return res;
//     })
//   );
// }

deleteStudyMaterial(id:any){
  const API_URL = `${this.SERVER_URL}users/deleteStudyMaterials?study_id=${id}`;
  return this.http.delete(API_URL,id).pipe(
    map((res: any) => {
      return res;
    })
  );

}
studentStudyMaterial(data:any){
  const query=this.objToQueryString(data)
  const API_URL = `${this.SERVER_URL}users/getStudyMaterial?${query}`;
  return this.http.get(API_URL).pipe(
    map((res: any) => {
      return res;
    })
  );
}
getSEO(data:any){
  const API_URL = `${this.SERVER_URL}users/page/meta/tags/${data}`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );    
}

schoolAdmitCardList(data:any){
  const query=this.objToQueryString(data)
  const API_URL = `${this.SERVER_URL}users/getAdmitCardList?${query}`;
  return this.http.get(API_URL).pipe(
    map((res: any) => {
      return res;
    })
  );
}
//---------certificate for school and student Both

getCertificate_School_Student(data:any){
  const query=this.objToQueryString(data)
  const API_URL = `${this.SERVER_URL}users/getCertificateList?${query}`;
  return this.http.get(API_URL).pipe(
    map((res: any) => {
      return res;
    })
  );
}
getExamURL(data:any){
  const API_URL = `${this.SERVER_URL}users/exam`;
  return this.http.post(API_URL,data).pipe(
    map((res: any) => {
      return res;
    })
  );
}
getResultStudent(){
  const API_URL = `${this.SERVER_URL}users/getStudentResult`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
}
getResultSchool(data:any){
  const query=this.objToQueryString(data)
  const API_URL = `${this.SERVER_URL}users/getResultForSchool?${query}`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
}
//-------Student Profile Annoucements
getAnnouncements(){
  const API_URL = `${this.SERVER_URL}users/getProfileAnnouncement`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
 }

 //------photo Gallery home page
 getPhotoGallery(data:any){
  const query=this.objToQueryString(data)
  const API_URL = `${this.SERVER_URL}users/getPhotoGallery?${query}`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
 }

 //---------------2Mar
 payment(data: any): Observable<any> {
  const API_URL = `${this.SERVER_URL}payment/payumoney`;
  return this.http.post(API_URL, data).pipe(
    map((res) => {
      return res;
    })
  );
}

studentExamForm(data:any){
  const API_URL = `${this.SERVER_URL}users/studentExamForm`;
  return this.http.post(API_URL, data).pipe(
    map((res) => {
      return res;
    })
  );
}

getschool(obj: any): Observable<any> {
  const API_URL = `${this.SERVER_URL}users/getSchool?search=${obj}`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
}
getsubject(): Observable<any> {
  const API_URL = `${this.SERVER_URL}users/getSubject`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
}
getlanguage(): Observable<any> {
  const API_URL = `${this.SERVER_URL}users/getLanguage`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
}

// getaboutMtse(): Observable<any> {
//   const API_URL = `${this.SERVER_URL}users/getAboutExam`;
//   return this.http.get(API_URL).pipe(
//     map((res) => {
//       return res;
//     })
//   );
// }

getUserFromB2C(data: any): Observable<any> {
  const query = this.objToQueryString(data);

  const API_URL = `${this.SERVER_URL}users/getUserFromB2C?${query}`;
  return this.http.get(API_URL).pipe(
    map((res) => {
      return res;
    })
  );
}


//sayali code


  profileupdate(data: any): Observable<any> {
    const API_URL = `${this.SERVER_URL}profile/school/updateContactInfo`;
   return this.http.put(API_URL, data).pipe(
      map((res) => {
        return res;
      })
    );
  }

  //  ===== Mock Test Series =====

  getAssessments(){
    const API_URL = `${this.SERVER_URL}users/assessments`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getLiveTests(){
    const API_URL = `${this.SERVER_URL}users/tests?testType=live`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  generateUserExamToken(testId:any){
    const API_URL = `${this.SERVER_URL}users/generateUserExamToken`;
    return this.http.post(API_URL, testId).pipe(
      map((res) => {
        return res;
      })
    );
  }

  createMockTestPayment(testId:any){
    const API_URL = `${this.SERVER_URL}users/createMockTestPayment`;
    return this.http.post(API_URL, testId).pipe(
      map((res) => {
        return res;
      })
    );
  }
  
  makeTestPayment(data:any , parchaseInfo:any , testingKey?: string){
    let API_URL = `${this.SERVER_URL}users/makeTestPayment`;

    if (testingKey) {
      API_URL += `?testing=${testingKey}`;
    }
    return this.http.post(API_URL, {data, parchaseInfo}).pipe(
      map((res) => {
        return res;
      })
    );
  }

  testPaymentStatus(txnId:any){
    const API_URL = `${this.SERVER_URL}users/testPaymentStatus?txnId=${txnId}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  mockTestInvoice(paymentId:any){
    const API_URL = `${this.SERVER_URL}users/mockTestInvoice?paymentId=${paymentId}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  mockTestReceipt(paymentId:any){
    const API_URL = `${this.SERVER_URL}users/mockTestReceipt?paymentId=${paymentId}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  transactionReceipt(txnDocId:any){
    const API_URL = `${this.SERVER_URL}users/receipt/${txnDocId}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  schoolMockTestAnalytics(){
    const API_URL = `${this.SERVER_URL}users/schoolMockTestAnalytics`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }
  
  shareCredentials(obj:any){
    const API_URL = `${this.SERVER_URL}users/shareCredentials`;
    return this.http.patch(API_URL,obj).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getUserAssessmentResult(userAssessmentId: string): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/userAssessmentResult?userAssessmentId=${userAssessmentId}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getStates(countryCode: string): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/getStates?country_code=${countryCode}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getTrasactionsByUser(): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/purchaseHistory`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

  getCertificate(userAssessmentId: string): Observable<any> {
    const API_URL = `${this.SERVER_URL}users/certificate/${userAssessmentId}`;
    return this.http.get(API_URL).pipe(
      map((res) => {
        return res;
      })
    );
  }

}
